export default "__VITE_ASSET__1GfL1KHY__"